import React from 'react';
import ReactDOM from 'react-dom/client';
import "@xyflow/react/dist/style.css";

import './index.css';
import App from './App';
import { HelmetProvider } from "react-helmet-async";
import { MyContextProvider } from './Context/MyContext';
import { MyStateProvider } from './Context/UseStateContet';

// import Navbar from './Navbar/Navbar';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <MyContextProvider>
      <MyStateProvider>
        {/* <React.StrictMode> */}
        <App />
        {/* </React.StrictMode> */}
      </MyStateProvider>
    </MyContextProvider>
  </HelmetProvider>
);

